import { axios, Response } from '../index'

const removePatientOfGroup = (
  groupId: string,
  patientId: string
): Response<Body> => {
  return axios.delete(`/v1/groups/${groupId}/patients/${patientId}`)
}

export default removePatientOfGroup
